import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $ProfileSidebarModuleName } from "./profileSidebar.types";

const getProfileSidebar = (state: IState) =>
    getValueState(state, $ProfileSidebarModuleName);

export { getProfileSidebar };
